<div class="_w-full">
    <div *ngIf="collapsableSearchInput"  
        class="_w-7 _h-7 _ml-nudge-4 _flex _items-center _justify-center _cursor-pointer _bg-white _border-primary-1 _border-2 _rounded-full hover:_bg-primary-4-tint-10 _transition-all-medium _text-lg" 
        (click)="activateSearchInput()">
        <i class="fa-light fa-microchip-ai _text-primary-1 _text-xl"></i>
    </div>

    <fieldset *ngIf="showSearchInput || !collapsableSearchInput" 
        [formGroup]="formGroup"
        class="_w-full _h-form-field _top-0 _left-0 _bg-transparent _flex _items-center _z-20"
        [ngClass]="[
            showSearchInput ? '_border-transparent' : '',
            collapsableSearchInput ? '_absolute' : '_relative',
            inputModifierClasses ? inputModifierClasses : '']">
        <input 
            #aiSearchTextInput
            class="_absolute _left-0 _w-full _px-8 _bg-white _z-10 _input-rounded _h-form-field-fat _bg-transparent _border-primary-1 _outline-inset _shadow" 
            [ngClass]="{ '_font-bold' : isActive }"
            type="text" 
            [placeholder]="placeholderText"
            formControlName="aiSearchTextValue"
            [(value)]="searchTerm">
        
        <i class="fa-light fa-microchip-ai _z-20 _text-primary-1 _text-xl _px-3" [ngClass]="isActive ? 'fa-fade' : '' "></i>

        <i id="closeAiSearchInput"
        [ngClass]="{ 
            '_text-primary-1-tint-20 _pointer-events-none _cursor-default' : !searchTerm, 
            '_cursor-pointer' : searchTerm
        }"
        class="fa-light fa-xmark _z-10 _absolute _right-4" 
        (click)="closeSearchInput()"></i>
    </fieldset>
</div>
